//logo
const FIELD_IS_ADD_LOGO = 'Add a logo';
const FIELD_LOGO_PLACEMENT = 'Logo placement';
const FIELD_LOGO = 'Logo';
const FIELD_NEW_IS_ADD_LOGO = 'add a logo';
const FIELD_LOGO_CLASS = 'add-a-logo01';
const FIELD_LOGO_PLACEMENT_CLASS = 'logo-placement-01';

//Another logo
const FIELD_ADD_ANOTHER_LOGO = 'Add another logo';
const FIELD_ANOTHER_LOGO_PLACEMENT = 'Another logo placement';
const FIELD_ANOTHER_LOGO = 'Another logo';
const FIELD_NEW_ADD_ANOTHER_LOGO = 'Add another logo';
const FIELD_ANOTHER_LOGO_CLASS = 'add-another-logo01';
const FIELD_ANOTHER_LOGO_PLACEMENT_CLASS = 'another-logo-placement-01';

//name
const FIELD_IS_ADD_PLAYER_NAME = 'Add player name';
const FIELD_PLAYER_FONT_NAME = 'Player font name';
const FIELD_PLAYER_NAME_COLOR = 'Player name color';
const FIELD_PLAYER_NAME = 'Player name';
const FIELD_PLAYER_NAME_CLASS = 'player-name-01';

//number
const FIELD_IS_ADD_PLAYER_NUMBER = 'Add player number';
const FIELD_PLAYER_NUMBER = 'Player number';
const FIELD_PLAYER_NUMBER_LOCATION = 'Player number location 01';
const FIELD_NUMBER_STYLE = 'Number font name';
const FIELD_NUMBER_COLOR = 'Number font color';
const FIELD_PLAYER_NUMBER_CLASS = 'player-number-01';
const FIELD_PLAYER_NUMBER_LOCATION_CLASS = 'select-location-number';

//another number
const FIELD_ADDITIONAL_PLAYER_NUMBER = 'Add additional number';
const FIELD_IS_ADDITIONAL_NUMBER_LOCATIOM = 'Add additional number location';
const FIELD_ADDITIONAL_NUMBER_LOCATIOM = 'Player number location 02';
const FIELD_ADDITIONAL_PLAYER_NUMBER_CLASS = 'add-additional-number';
const FIELD_ADDITIONAL_PLAYER_NUMBER_LOCATION_CLASS = 'select-additional-location-number';

//Custom printing
const FIELD_IS_CUSTOM_PRINTING = 'Add custom printing';
const FIELD_IS_CUSTOM_PRINTING_FILE = 'Custom printing file';
const FIELD_IS_CUSTOM_PRINTING_DESC = 'Custom printing description';
const FIELD_IS_CUSTOM_PRINTING_CLASS = 'additional-custom-printing'; //new

const FIELD_CLASS_mappings = [
    {
        className: FIELD_LOGO_PLACEMENT_CLASS,
        key: 'logo'
    },
    {
        className: FIELD_ANOTHER_LOGO_PLACEMENT_CLASS,
        key: 'anotherLogo'
    },
    {
        className: FIELD_PLAYER_NAME_CLASS,
        key: 'playerName'
    },
    {
        className: FIELD_PLAYER_NUMBER_CLASS,
        key: 'playerNumber'
    },
    {
        className: FIELD_ADDITIONAL_PLAYER_NUMBER_CLASS,
        key: 'additionalN'
    }
];

class TeamOrderRoster {
    constructor(options = {}) {
        if (!window.GPOConfigs || !window.GPOConfigs.option || !window.GPOConfigs.product || window.GPOConfigs.product.id != options.productId) {
            document.getElementById('team-roster').classList.add('hide');
            return;
        }

        //this.optionSetId = '1159557';
        const gpoApp = document.querySelector('.gpo-app');
        this.optionSetId = gpoApp?.dataset.optionSetId || '';
        if(!this.optionSetId) {
            console.warn('Option Set ID not found. Team Roster features may not work correctly.');
            return;
        }

        this.productId = options.productId;
        this.variantId = options.variantId;
        this.variants = options.variants || [];
        this.productOptions = options.productOptions || [];

        this.globoPrices = this.extractGloboConfig().prices;       
        this.globoVariants = this.extractGloboConfig().variantVirtualIds;

        this.selectedColor = this.getCurrentSelectedColor();

        this.cartKey = null;
        this.players = [];
        this.handleRosterAddToCart = this.handleRosterAddToCart.bind(this);

        this.init();
    }

    async init() {
        this.bindEvents();
        this.bindFontColorPreview();
        this.bindDropdownEvents();
        //this.addInitialPlayers();
        this.bindMainProductFormSync();
        this.bindModalEvents();
        this.bindAddToCart();
        //this.bindModalAutoSave();
        this.bindTeamRosterValidation();
        await this.initCartKey();
        this.clearPersistedRosterOnInit();

        this.loadRosterFromStorage();
    }

    async initCartKey () {
        const response = await fetch('/cart.js');
        const cartData = await response.json();

        this.cartKey = cartData.token;
    }

    extractGloboConfig() {
        const prices = {
            playerName: null,
            playerNumber: null,
            logo: null,
            anotherLogo: null,
            additionalN: null
        };

        const variantVirtualIds = {
            playerName: null,
            playerNumber: null,
            logo: null,
            anotherLogo: null,
            additionalN: null
        };

        try {
            if (window.GPOConfigs && window.GPOConfigs.options[this.optionSetId] && window.GPOConfigs.options[this.optionSetId].flatElements) {
                const elements = window.GPOConfigs.options[this.optionSetId].flatElements;

                elements.forEach(element => {
                    if (element.type === 'checkbox' && element.option_values) {
                        const optionValue = element.option_values[0];
                        if (optionValue && optionValue.variant_price) {
                            const price = parseFloat(optionValue.variant_price);

                            switch (element.label_on_cart) {
                                case FIELD_IS_ADD_LOGO:
                                    prices.logo = price;
                                    variantVirtualIds.logo = optionValue.variant_id;
                                    break;
                                case FIELD_ADD_ANOTHER_LOGO:
                                    prices.anotherLogo = price;
                                    variantVirtualIds.anotherLogo = optionValue.variant_id;
                                    break;
                                case FIELD_IS_ADD_PLAYER_NAME:
                                    prices.playerName = price;
                                    variantVirtualIds.playerName = optionValue.variant_id;
                                    break;
                                case FIELD_IS_ADD_PLAYER_NUMBER:
                                    prices.playerNumber = price;
                                    variantVirtualIds.playerNumber = optionValue.variant_id;
                                    break;

                                case FIELD_IS_ADDITIONAL_NUMBER_LOCATIOM:
                                    prices.additionalN = price;
                                    variantVirtualIds.additionalN = optionValue.variant_id;
                                    break;
                            }
                        }
                    }
                });
            }
        } catch (error) {
            console.warn('⚠️ Error extracting Globo prices, using defaults:', error);
        }

        return {
            prices,
            variantVirtualIds,
        };
    }

    getCurrentSelectedColor() {
        const formColor = this.getSelectedColorFromForm();
        if (formColor) {
            return formColor;
        }

        const currentVariant = this.variants.find(v => v.id == this.variantId);

        let selectedColor;
        if (currentVariant) {
            selectedColor = currentVariant.option1;
        } else if (this.variants[0]) {
            selectedColor = this.variants[0].option1;
        } else {
            const colorInput = document.querySelector('input[name="Color"]:checked, input[name="color"]:checked');
            const colorSelect = document.querySelector('select[name="Color"], select[name="color"]');

            if (colorInput) {
                selectedColor = colorInput.value;
            } else if (colorSelect) {
                selectedColor = colorSelect.value;
            } else {
                selectedColor = 'Default';
            }
        }

        return selectedColor;
    }

    getSelectedColorFromForm() {
        const colorInput = document.querySelector('input[name="Color"]:checked, input[name="color"]:checked');
        const colorSelect = document.querySelector('select[name="Color"], select[name="color"]');
        const variantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"], .product-variant-id, input[name="id"]');
        const currentVariant = this.variants.find(v => v.id == variantInput?.value);

        if (currentVariant?.option1) {
            return currentVariant.option1;
        }

        if (colorInput?.value) {
            return colorInput.value;
        }

        if (colorSelect?.value) {
            return colorSelect.value;
        }

        return '';
    }

    syncSelectedColor(value) {
        const nextColor = value || this.getCurrentSelectedColor();
        if (!nextColor || nextColor === this.selectedColor) {
            return;
        }

        this.selectedColor = nextColor;
        this.players.forEach(player => this.updatePlayerSizeOptions(player.id));
        this.updateTotal();
        this.resetRosterApplyState();
    }

    getAvailableSizesForColor(color) {
        const availableVariants = this.variants.filter(variant =>
            variant.option1 === color && variant.available
        );

        const sizes = [...new Set(availableVariants.map(variant => variant.option2))];
        return sizes.filter(size => size);
    }

    getVariantByOptions(color, size) {
        return this.variants.find(variant =>
            variant.option1 === color &&
            variant.option2 === size &&
            variant.available
        );
    }

    updatePlayerSizeOptions(playerId) {
        const playerRow = document.querySelector(`[data-player-id="${playerId}"]`);
        if (!playerRow) return;

        const sizeSelect = playerRow.querySelector('.size-select');
        const currentSize = this.getSelectedSize(playerId);
        const availableSizes = this.getAvailableSizesForColor(this.selectedColor);

        const dropdown = sizeSelect.querySelector('.select-dropdown');
        const sizeOptions = availableSizes.map(size =>
            `<li class="size-option" data-value="${size}" ${size === currentSize ? 'data-selected="true"' : ''}>${size}</li>`
        ).join('');

        dropdown.innerHTML = sizeOptions;

        if (!availableSizes.includes(currentSize) && availableSizes.length > 0) {
            this.setSelectedSize(playerId, availableSizes[0]);
            this.updatePlayer(playerId, { size: availableSizes[0] });
        }
    }

    bindMainProductFormSync() {
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) {
            qtyInput.addEventListener('change', (e) => {
                this.syncFromMainProductForm('quantity', parseInt(e.target.value) || 1);
            });
        }

        const sizeInputs = document.querySelectorAll('input[name="Size"], input[name="size"]');
        sizeInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.syncFromMainProductForm('size', e.target.value);
                }
            });
        });

        const sizeSelects = document.querySelectorAll('select[name="Size"], select[name="size"]');
        sizeSelects.forEach(select => {
            select.addEventListener('change', (e) => {
                this.syncFromMainProductForm('size', e.target.value);
            });
        });

        const colorInputs = document.querySelectorAll('input[name="Color"], input[name="color"]');
        colorInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                if (e.target.type === 'radio' && !e.target.checked) {
                    return;
                }

                this.syncFromMainProductForm('color', e.target.value);
            });
        });

        const colorSelects = document.querySelectorAll('select[name="Color"], select[name="color"]');
        colorSelects.forEach(select => {
            select.addEventListener('change', (e) => {
                this.syncFromMainProductForm('color', e.target.value);
            });
        });

        document.addEventListener('input', (e) => {
            if (
                e.target.matches('.gpo-element.logo-placement-01.input-player-name input.gpo-input') ||
                e.target.matches('.gpo-element.logo-placement-01.play-number-input:not(.play-number-input-hidden) input.gpo-input')
            ) {
                this.syncVisibleGloboFieldsToRoster();
            }
        });

        document.addEventListener('change', (e) => {
            if (
                e.target.matches('.gpo-element.logo-placement-01.input-player-name input.gpo-input') ||
                e.target.matches('.gpo-element.logo-placement-01.play-number-input:not(.play-number-input-hidden) input.gpo-input') ||
                e.target.matches('.gpo-element.select-location-number.logo-placement-01 input[type="radio"]')
            ) {
                window.setTimeout(() => this.syncVisibleGloboFieldsToRoster(), 120);
                window.setTimeout(() => this.syncVisibleGloboFieldsToRoster(), 260);
            }
        });
    }

    bindModalEvents() {
        const modalOpener = document.querySelector('[data-modal*="CreateRoster"]');
        if (modalOpener) {
            modalOpener.addEventListener('click', () => {
                setTimeout(() => {
                    this.selectedColor = this.getCurrentSelectedColor();
                    this.initPrices();
                    this.clearAllPlayers();
                    this.addInitialPlayers();
                    this.loadRosterFromStorage();
                    //this.resetRosterApplyState();
                }, 100);
            });
        }
    }

    syncFromMainProductForm(field, value) {
        if (field === 'color') {
            this.syncSelectedColor(value);
        }
    }

    isActiveGloboInput(input) {
        if (!input || input.disabled) return false;

        const style = window.getComputedStyle(input);
        return style.display !== 'none'
            && style.visibility !== 'hidden'
            && input.offsetParent !== null;
    }

    getActiveGloboPlayerNameInput() {
        return [...document.querySelectorAll('.gpo-element.logo-placement-01.input-player-name input.gpo-input')]
            .find((input) => this.isActiveGloboInput(input)) || null;
    }

    getActiveGloboPlayerNumberInput() {
        return [...document.querySelectorAll('.gpo-element.logo-placement-01.play-number-input:not(.play-number-input-hidden) input.gpo-input')]
            .find((input) => this.isActiveGloboInput(input)) || null;
    }

    syncVisibleGloboFieldsToRoster() {
        const mainPlayer = this.players.find(player => player.isMainProduct);
        if (!mainPlayer) return;

        const playerRow = document.querySelector(`[data-player-id="${mainPlayer.id}"]`);
        if (!playerRow) return;

        const activeNameInput = this.getActiveGloboPlayerNameInput();
        const activeNumberInput = this.getActiveGloboPlayerNumberInput();

        const nextName = activeNameInput?.value?.trim() || '';
        const nextNumber = activeNumberInput?.value?.trim() || '';

        const rosterNameInput = playerRow.querySelector('.player-name');
        const rosterNumberInput = playerRow.querySelector('.player-number');

        if (rosterNameInput && rosterNameInput.value !== nextName) {
            rosterNameInput.value = nextName;
        }

        if (rosterNumberInput && rosterNumberInput.value !== nextNumber) {
            rosterNumberInput.value = nextNumber;
        }

        this.updatePlayer(mainPlayer.id, {
            playerName: nextName,
            playerNumber: nextNumber
        });
    }

    bindTeamRosterValidation() {
        document.addEventListener("click", (e) => {
            const rosterBtn = e.target.closest('#team-roster button');
            if (!rosterBtn) return;

            // Run validation before modal opens
            if (!this.validateRequiredFields()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }

            // Mark roster as active if passes
            const hiddenCheckbox = document.querySelector('input[name="is_apply_create_roster"]');
            if (hiddenCheckbox) {
                hiddenCheckbox.value = 'true';
                hiddenCheckbox.checked = true;
            }
        }, { capture: true });
    }

    bindEvents() {
        document.querySelector('.add-player-btn')?.addEventListener('click', () => {
            this.addPlayer();
        });

        document.querySelector('.save-roster-btn')?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.saveRoster();
        });

        document.addEventListener('change', (e) => {
            if (e.target.matches('.quantity__input, .player-number, .player-name')) {
                this.resetRosterApplyState();
                this.updatePricing();
            }
        });

        document.addEventListener('change', (e) => {
            if (!this.isRosterApplied()) {
                return;
            }

            if (!e.target.closest?.('.gpo-container')) {
                return;
            }

            this.invalidateRosterState();
        });

        const updatePlayerNameAddonPrice = (group) => {
            if (!group) {
                return;
            }
        
            const checkedRadio = group.querySelector(
                '.gpo-group__childs .select-location-number input[type="radio"]:checked'
            );
        
            const labelValue = group.querySelector('.choicelist-item__value');        
            if (!checkedRadio || !labelValue) {
                return;
            }
        
            const price = parseFloat(checkedRadio.dataset.addonPrice || 0);        
            labelValue.querySelector('.addOn')?.remove();        
            if (price > 0) {
                labelValue.insertAdjacentHTML(
                    'beforeend',
                    `<span class="addOn">(+ $${price.toFixed(2)})</span>`
                );
            }
        };

        document.addEventListener('change', (e) => {
            const checkbox = e.target;
        
            if (!checkbox.matches('.gpo-container input[type="checkbox"]')) {
                return;
            }
            
            if (checkbox.value.toLowerCase() !== 'add a player number') {
                return;
            }
        
            updatePlayerNameAddonPrice(checkbox.closest('.gpo-group'));
        });
        
        document.addEventListener('change', (e) => {
            const radio = e.target;
        
            if (!radio.matches('.select-location-number input[type="radio"]')) {
                return;
            }
        
            updatePlayerNameAddonPrice(radio.closest('.gpo-group'));
        });

        //Add a click listener for custom dropdown options
        document.addEventListener('click', (e) => {
            if (e.target.matches('.size-option')) {
                const sizeValue = e.target.dataset.value;
                const sizeSelect = e.target.closest('.size-select');

                if (sizeSelect) {
                    // Update display value
                    const display = sizeSelect.querySelector('.select-display');
                    if (display) {
                        display.dataset.value = sizeValue;
                        const textEl = display.querySelector('.select-text');
                        if (textEl) textEl.textContent = sizeValue;
                    }
                }

                // ✅ Trigger your reset & price update
                this.resetRosterApplyState();
                this.updatePricing();
            }
        });

        document.addEventListener('click', (e) => {
            const removeBtn = e.target.closest('.remove-player-btn');
            if (removeBtn) {
                const playerId = removeBtn.dataset.playerId;
                this.removePlayer(playerId);
            }
        });
    }

    bindAddToCart() {
        // The listeners are registered early by snippets/team-order.liquid (ahead of Globo); only swap the handler here
        if (window.__teamRosterAtcDispatcher) {
            window.__teamRosterAddToCartHandler = (event) => this.handleRosterAddToCart(event);
            return;
        }

        if (window.__teamRosterAddToCartHandler) {
            window.removeEventListener('click', window.__teamRosterAddToCartHandler, true);
            document.removeEventListener('submit', window.__teamRosterAddToCartHandler, true);
        }

        window.__teamRosterAddToCartHandler = (event) => this.handleRosterAddToCart(event);
        window.addEventListener('click', window.__teamRosterAddToCartHandler, true);
        document.addEventListener('submit', window.__teamRosterAddToCartHandler, true);
    }

    getRosterAddToCartTrigger(event) {
        const selector = '.gpo-clone-atc-button, .gpo-original-atc-button, button[name="add"], .product-form__submit';

        if (event?.type === 'submit') {
            const submitter = event.submitter;
            return submitter?.matches?.(selector) ? submitter : null;
        }

        const target = event?.target || null;
        if (!target || typeof target.closest !== 'function') {
            return null;
        }

        return target.closest(selector);
    }

    isRosterApplied() {
        const rosterInput = document.querySelector('input[name="is_apply_create_roster"]');
        if (!rosterInput) {
            return false;
        }

        const isFlagged = rosterInput.value === 'true' || rosterInput.checked === true;
        if (!isFlagged) {
            return false;
        }

        const savedRoster = this.getSavedRoster();
        return Array.isArray(savedRoster?.players) && savedRoster.players.length > 0;
    }

    setRosterApplyState(isApplied) {
        const rosterInput = document.querySelector('input[name="is_apply_create_roster"]');
        if (!rosterInput) {
            return;
        }

        rosterInput.value = isApplied ? 'true' : 'false';
        rosterInput.checked = !!isApplied;
    }

    buildRosterMainProduct(form) {
        const formData = new FormData(form);
        const savedRoster = this.getSavedRoster();
        const rosterPlayers = Array.isArray(savedRoster?.players) ? savedRoster.players : [];
        const mainRosterPlayer = rosterPlayers.find(player => player?.isMainProduct);
        const rosterColor = this.getCurrentSelectedColor() || savedRoster?.selectedColor || this.selectedColor;
        this.selectedColor = rosterColor;

        const mainProduct = {
            // The theme's input[name="id"] is rendered disabled, so FormData skips it
            id: formData.get('id') || form.querySelector('input[name="id"]')?.value || this.variantId,
            quantity: formData.get('quantity') || 1,
            properties: this.getSelectedProperties()
        };

        if (!mainRosterPlayer) {
            return mainProduct;
        }

        const mainVariant = this.getVariantByOptions(rosterColor, mainRosterPlayer.size);
        if (mainVariant?.id) {
            mainProduct.id = mainVariant.id;
        }

        mainProduct.quantity = mainRosterPlayer.quantity || 1;

        const properties = structuredClone
            ? structuredClone(mainProduct.properties || {})
            : JSON.parse(JSON.stringify(mainProduct.properties || {}));


        this.applyRosterPlayerToProperties(properties, mainRosterPlayer);

        mainProduct.properties = properties;
        return mainProduct;
    }

    applyRosterPlayerToProperties(properties, player) {
        if (!properties || !player) {
            return properties;
        }

        const rosterNumber = player.playerNumber?.toString().trim() || '';
        const rosterName = player.playerName?.toString().trim() || '';
        const skipNumberKeys = /font|color|location|style/i;
        const skipNameKeys = /font|color|description/i;

        Object.keys(properties).forEach((key) => {
            const normalizedKey = String(key || '').toLowerCase();
            const currentValue = properties[key];

            const shouldSyncNumber =
                normalizedKey.includes('number') &&
                !skipNumberKeys.test(normalizedKey) &&
                (typeof currentValue === 'string' || typeof currentValue === 'number');

            const shouldSyncName =
                normalizedKey.includes('name') &&
                !skipNameKeys.test(normalizedKey) &&
                (typeof currentValue === 'string' || typeof currentValue === 'number');

            if (shouldSyncNumber) {
                if (rosterNumber) {
                    properties[key] = rosterNumber;
                } else {
                    delete properties[key];
                }
                return;
            }

            if (shouldSyncName) {
                if (rosterName) {
                    properties[key] = rosterName;
                } else {
                    delete properties[key];
                }
            }
        });

        if (rosterName) {
            properties[FIELD_PLAYER_NAME] = rosterName;
        } else {
            delete properties[FIELD_PLAYER_NAME];
        }

        if (rosterNumber) {
            properties[FIELD_PLAYER_NUMBER] = rosterNumber;
        } else {
            delete properties[FIELD_PLAYER_NUMBER];
        }

        return properties;
    }

    async handleRosterAddToCart(e) {
        const button = this.getRosterAddToCartTrigger(e);
        if (!button) {
            return;
        }

        if (!this.isRosterApplied()) {
            return;
        }

        const form = button.closest('form[data-type="add-to-cart-form"]')
            || button.form
            || document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation();
        }

        const activeButton = button;
        if (activeButton.dataset?.teamRosterSubmitting === 'true' || activeButton.getAttribute('aria-disabled') === 'true') {
            return;
        }

        if (!this.validateRequiredFields()) {
            return;
        }

        activeButton.dataset.teamRosterSubmitting = 'true';
        activeButton.classList.add('loading');
        activeButton.setAttribute('aria-disabled', 'true');

        const span = activeButton.querySelector('span');
        const originalText = span?.dataset.originalText || span?.textContent?.trim() || 'Add to cart';
        if (span && !span.dataset.originalText) {
            span.dataset.originalText = originalText;
        }
        if (span) span.textContent = 'Adding to cart...';

        try {
            const mainProduct = this.buildRosterMainProduct(form);
            const cartItems = this.buildFinalCartItems(mainProduct, []);

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: cartItems.items
                })
            });

            if (!response.ok) {
                console.error('Failed to add roster items:', await response.text());
                alert('Unable to add this item to the cart. Please refresh the page and try again.');
                return;
            }

            this.clearRosterSession();
            window.location.href = '/cart';

        } catch (error) {
            console.error('Error adding products:', error);
        } finally {
            activeButton.classList.remove('loading');
            activeButton.removeAttribute('aria-disabled');
            delete activeButton.dataset.teamRosterSubmitting;
            if (span) {
                span.textContent = span.dataset.originalText || 'Add to cart';
            }
        }
    }

    bindFontColorPreview() {
        const getVisibleNode = (selectors) => {
            const nodes = Array.from(document.querySelectorAll(selectors));
            return nodes.find((node) => {
                if (!node) return false;
                const style = window.getComputedStyle(node);
                return style.display !== 'none' && style.visibility !== 'hidden' && node.offsetParent !== null;
            }) || nodes[0] || null;
        };
        const isNoSyncNode = (node) => Boolean(node?.closest?.('.no-sync'));
        const getSyncableVisibleNode = (selectors) => {
            const nodes = Array.from(document.querySelectorAll(selectors))
                .filter((node) => !isNoSyncNode(node));

            return nodes.find((node) => {
                if (!node) return false;
                const style = window.getComputedStyle(node);
                return style.display !== 'none' && style.visibility !== 'hidden' && node.offsetParent !== null;
            }) || nodes[0] || null;
        };
        const normalizeGloboText = (value) => String(value || '')
            .toLowerCase()
            .replace(/[\u2013\u2014]/g, '-')
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();

        const getNamePreviewNode = () => getSyncableVisibleNode('#paragraph-1 p, .font-name-preview-01 p');
        const getNumberPreviewNode = () => getSyncableVisibleNode('#paragraph-3 p, .font-name-preview-02 p');
        const getNumberPreviewContainer = () => getSyncableVisibleNode('#paragraph-3, .font-name-preview-02');
        const nameColorGroup = document.querySelector('.name-color-01');
        this.boundPreviewNameInput = this.boundPreviewNameInput || null;
        this.boundPreviewNumberInput = this.boundPreviewNumberInput || null;
        this.boundPreviewNameHandler = this.boundPreviewNameHandler || null;
        this.boundPreviewNumberHandler = this.boundPreviewNumberHandler || null;

        const previewText = getNamePreviewNode();
        const previewNum = getNumberPreviewNode();

        if (!previewText && !previewNum) {
            settimeout(() => this.bindFontColorPreview(), 500);
            return;
        }

        const isWhiteColor = (color) => {
            if (!color) return false;

            const normalized = color.trim().toLowerCase();
            if (normalized === '#fff' || normalized === '#ffffff' || normalized === 'white') {
                return true;
            }

            return normalized === 'rgb(255, 255, 255)' || normalized === 'rgba(255, 255, 255, 1)';
        };

        const applyPreviewColor = (selector, color) => {
            const element = getSyncableVisibleNode(selector);
            if (!element) return;

            const textNode = element.matches('p') ? element : element.querySelector('p') || element;
            const selectedColor = color || '#000';
            [element, textNode].filter(Boolean).forEach((node) => {
                node.style.setProperty('color', selectedColor, 'important');
                node.style.setProperty('-webkit-text-fill-color', selectedColor, 'important');
            });

            const backgroundTarget = element.matches('p') ? element : element;
            backgroundTarget.style.setProperty('background-color', isWhiteColor(selectedColor) ? '#d9d9d9' : 'transparent', 'important');
            if (textNode !== backgroundTarget) {
                textNode.style.setProperty('background-color', 'transparent', 'important');
            }
        };

        const applyNameColor = (color) => applyPreviewColor('#paragraph-1, .font-name-preview-01 p', color);
        const syncNamePreviewText = (value = '') => {
            const currentPreviewText = getNamePreviewNode();
            if (currentPreviewText) {
                currentPreviewText.textContent = value.trim() || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            }
        };
        const syncNamePreviewFromCurrentInput = () => {
            const currentNameInput = this.getActiveGloboPlayerNameInput?.() || getPlayerNameInput();
            syncNamePreviewText(currentNameInput?.value || '');
        };
        const syncNumberPreviewText = (value = '') => {
            const currentPreviewNum = getNumberPreviewNode();
            if (currentPreviewNum) {
                currentPreviewNum.textContent = value.trim() || '0123456789';
            }
        };
        const syncNumberPreviewFromCurrentInput = () => {
            const currentNumberInput = this.getActiveGloboPlayerNumberInput?.() || getPlayerNumberInput();
            syncNumberPreviewText(currentNumberInput?.value || '');
        };
        const applyNumberColor = (color) => {
            const container = getNumberPreviewContainer();
            const previewNode = getNumberPreviewNode();

            if (!container || !previewNode) return;

            const selectedColor = color || '#000';
            [container, previewNode].forEach((node) => {
                node.style.setProperty('color', selectedColor, 'important');
                node.style.setProperty('-webkit-text-fill-color', selectedColor, 'important');
            });

            container.style.setProperty('background-color', isWhiteColor(selectedColor) ? '#000' : 'transparent', 'important');
            previewNode.style.setProperty('background-color', 'transparent', 'important');
        };
        const liftNumberPreviewParagraph = () => {
            const container = getNumberPreviewContainer();
            const previewNode = getNumberPreviewNode();

            if (container) {
                container.style.setProperty('position', 'relative', 'important');
                container.style.setProperty('top', '0', 'important');
                container.style.setProperty('margin-bottom', '0', 'important');
            }

            if (previewNode) {
                previewNode.style.removeProperty('display');
                previewNode.style.removeProperty('width');
            }
        };
        const forceVisibleNumberInputsBlack = () => {
            const numberInputs = Array.from(document.querySelectorAll('.gpo-element.logo-placement-01.play-number-input input.gpo-input, .gpo-element.logo-placement-01.play-number-input-hidden input.gpo-input'));

            numberInputs.forEach((input) => {
                if (!this.isActiveGloboInput(input)) return;

                input.style.setProperty('color', '#000', 'important');
                input.style.setProperty('-webkit-text-fill-color', '#000', 'important');
                input.style.setProperty('caret-color', '#000', 'important');
            });
        };
        const getPlayerNameInput = () => document.querySelector('.input-player-name input[name="Player name"], .input-player-name input[data-name="properties[Player name]"], input[name="Player name"][data-name="properties[Player name]"]');
        const getActiveNumberLocationValue = () => document.querySelector('.select-location-number input[type="radio"]:checked')?.value || '';
        const getPlayerNumberInput = () => {
            const activeLocation = normalizeGloboText(getActiveNumberLocationValue());
            const inputs = Array.from(document.querySelectorAll('.gpo-element.logo-placement-01.play-number-input input.gpo-input, .gpo-element.logo-placement-01.play-number-input-hidden input.gpo-input'));
            const visibleInputs = inputs.filter((input) => this.isActiveGloboInput(input));

            const matchedInput = visibleInputs.find((input) => normalizeGloboText(input.name) === activeLocation)
                || visibleInputs.find((input) => normalizeGloboText(input.dataset.fieldName) === activeLocation)
                || visibleInputs.find((input) => normalizeGloboText(input.closest('.gpo-element')?.querySelector('.gpo-label .label-content')?.textContent) === activeLocation);

            return matchedInput || null;
        };
        const bindActivePreviewInputs = () => {
            const nextNameInput = this.getActiveGloboPlayerNameInput?.() || getPlayerNameInput();
            const nextNumberInput = this.getActiveGloboPlayerNumberInput?.() || getPlayerNumberInput();

            if (this.boundPreviewNameInput !== nextNameInput) {
                if (this.boundPreviewNameInput && this.boundPreviewNameHandler) {
                    this.boundPreviewNameInput.removeEventListener('input', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.removeEventListener('change', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.removeEventListener('blur', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.removeEventListener('gpoFakeChange', this.boundPreviewNameHandler, true);
                }

                this.boundPreviewNameInput = nextNameInput;
                this.boundPreviewNameHandler = nextNameInput
                    ? () => requestAnimationFrame(() => syncNamePreviewFromCurrentInput())
                    : null;

                if (this.boundPreviewNameInput && this.boundPreviewNameHandler) {
                    this.boundPreviewNameInput.addEventListener('input', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.addEventListener('change', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.addEventListener('blur', this.boundPreviewNameHandler, true);
                    this.boundPreviewNameInput.addEventListener('gpoFakeChange', this.boundPreviewNameHandler, true);
                }
            }

            if (this.boundPreviewNumberInput !== nextNumberInput) {
                if (this.boundPreviewNumberInput && this.boundPreviewNumberHandler) {
                    this.boundPreviewNumberInput.removeEventListener('input', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.removeEventListener('change', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.removeEventListener('blur', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.removeEventListener('gpoFakeChange', this.boundPreviewNumberHandler, true);
                }

                this.boundPreviewNumberInput = nextNumberInput;
                this.boundPreviewNumberHandler = nextNumberInput
                    ? () => requestAnimationFrame(() => syncNumberPreviewFromCurrentInput())
                    : null;

                if (this.boundPreviewNumberInput && this.boundPreviewNumberHandler) {
                    this.boundPreviewNumberInput.addEventListener('input', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.addEventListener('change', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.addEventListener('blur', this.boundPreviewNumberHandler, true);
                    this.boundPreviewNumberInput.addEventListener('gpoFakeChange', this.boundPreviewNumberHandler, true);
                }
            }

            syncNamePreviewFromCurrentInput();
            syncNumberPreviewFromCurrentInput();
            forceVisibleNumberInputsBlack();
            liftNumberPreviewParagraph();
        };
        const scheduleInitialPreviewSync = (attempt = 0) => {
            const nextNameInput = this.getActiveGloboPlayerNameInput?.() || getPlayerNameInput();
            const nextNumberInput = this.getActiveGloboPlayerNumberInput?.() || getPlayerNumberInput();
            const ready =
                (nextNameInput && this.isActiveGloboInput(nextNameInput)) ||
                (nextNumberInput && this.isActiveGloboInput(nextNumberInput));

            if (!ready) {
                if (attempt < 10) {
                    setTimeout(() => scheduleInitialPreviewSync(attempt + 1), 100);
                }
                return;
            }

            bindActivePreviewInputs();
        };

        if (!this.boundPreviewSyncDelegates) {
            this.boundPreviewSyncDelegates = true;
            const handleDelegatedPreviewSync = (e) => {
                if (e.target.matches('.gpo-element.logo-placement-01.input-player-name input.gpo-input')) {
                    requestAnimationFrame(() => {
                        syncNamePreviewText(e.target.value);
                    });
                }

                if (e.target.matches('.gpo-element.logo-placement-01.play-number-input:not(.play-number-input-hidden) input.gpo-input')) {
                    requestAnimationFrame(() => {
                        syncNumberPreviewText(e.target.value);
                    });
                }
            };

            document.addEventListener('input', handleDelegatedPreviewSync, true);
            document.addEventListener('change', handleDelegatedPreviewSync, true);
        }

        const checkedNameColor = nameColorGroup?.querySelector(`input[name="${FIELD_PLAYER_NAME_COLOR}"]:checked`);
        if (checkedNameColor) {
            applyNameColor(checkedNameColor.dataset.color1 || checkedNameColor.value || '#000');
        }

        const checkedNumberColor = document.querySelector(`input[name="${FIELD_NUMBER_COLOR}"]:checked`);
        if (checkedNumberColor) {
            applyNumberColor(checkedNumberColor.dataset.color1 || checkedNumberColor.value || '#000');
        }
        forceVisibleNumberInputsBlack();
        liftNumberPreviewParagraph();

        scheduleInitialPreviewSync();

        document.addEventListener('gpoRenderCompleted', () => {
            scheduleInitialPreviewSync();
        });

        // Delegate change events for dynamically loaded inputs
        document.addEventListener('change', (e) => {

            // --- Player name font ---
            if (e.target.matches(`input[name="${FIELD_PLAYER_FONT_NAME}"]`)) {
                const currentPreviewText = getNamePreviewNode();
                if (currentPreviewText) {
                    currentPreviewText.style.fontFamily = `'${e.target.value}', sans-serif`;
                }
            }

            // --- Player number font ---
            if (e.target.matches(`input[name="${FIELD_NUMBER_STYLE}"]`)) {
                const currentPreviewNum = getNumberPreviewNode();
                if (currentPreviewNum) {
                    currentPreviewNum.style.fontFamily = `'${e.target.value}', sans-serif`;
                }
            }

            // --- Player name color ---
            if (nameColorGroup && nameColorGroup.contains(e.target) && e.target.matches(`input[name="${FIELD_PLAYER_NAME_COLOR}"]`)) {
                applyNameColor(e.target.dataset.color1 || e.target.value || '#000');
            }

            // --- Player number color ---
            if (e.target.matches(`input[name="${FIELD_NUMBER_COLOR}"]`)) {
                applyNumberColor(e.target.dataset.color1 || e.target.value || '#000');
                forceVisibleNumberInputsBlack();
                liftNumberPreviewParagraph();
            }

            if (e.target.matches('.gpo-element.select-location-number.logo-placement-01 input[type="radio"]')) {
                window.setTimeout(() => {
                    scheduleInitialPreviewSync();
                }, 120);
            }
        });

    }

    getVariantIdByAttributes(player, mainProduct, variants) {
        const size = player.size?.toString().trim() || '';
        const color = this.getCurrentSelectedColor() || this.selectedColor || '';
        this.selectedColor = color;

        const matchedVariant = variants.find(v =>
            v.option1 === color &&
            v.option2 === size &&
            v.available
        );

        if (matchedVariant?.id) {
            return matchedVariant.id;
        }

        return (
            variants.find(v => {
                // Compare whole option segments ("Black / L"), not substrings, so "L" doesn't match "Black / XS"
                const parts = String(v.public_title || '').toLowerCase().split(' / ').map(part => part.trim());
                const hasSize = size && parts.includes(size.toLowerCase());
                const hasColor = color ? parts.includes(color.toLowerCase()) : true;
                return hasSize && hasColor;
            })?.id || null
        );
    }

    buildFinalCartItems(mainProduct, extraOfMainProduct = []) {
        const rosterData = this.getSavedRoster();
        const players = Array.isArray(rosterData?.players) ? rosterData.players : [];
        // productData variants carry option1/option2/available; window.meta variants only have public_title
        const variants = this.variants.length ? this.variants : (window.meta?.product?.variants || []);
        const finalItems = [];
        const YES_TEXT = "Yes";

        // Helper function to apply "Yes ($price)" replacements
        const applyYesPriceProperties = (props) => {
            /*if (props[FIELD_IS_ADD_LOGO] !== undefined && this.globoPrices?.logo) {
                //props[FIELD_IS_ADD_LOGO] = `${YES_TEXT} (+$${this.globoPrices.logo.toFixed(2)})`;
                props[FIELD_IS_ADD_LOGO] = `${YES_TEXT}`;
            }
            if (props[FIELD_ADD_ANOTHER_LOGO] !== undefined && this.globoPrices?.anotherLogo) {
                //props[FIELD_ADD_ANOTHER_LOGO] = `${YES_TEXT} (+$${this.globoPrices.anotherLogo.toFixed(2)})`;
                props[FIELD_ADD_ANOTHER_LOGO] = `${YES_TEXT}`;
            }
            if (props[FIELD_IS_ADD_PLAYER_NAME] !== undefined && this.globoPrices?.playerName) {
                //props[FIELD_IS_ADD_PLAYER_NAME] = `${YES_TEXT} (+$${this.globoPrices.playerName.toFixed(2)})`;
                props[FIELD_IS_ADD_PLAYER_NAME] = `${YES_TEXT}`;
            }
            if (props[FIELD_IS_ADD_PLAYER_NUMBER] !== undefined && this.globoPrices?.playerNumber) {
                //props[FIELD_IS_ADD_PLAYER_NUMBER] = `${YES_TEXT} (+$${this.globoPrices.playerNumber.toFixed(2)})`;
                props[FIELD_IS_ADD_PLAYER_NUMBER] = `${YES_TEXT}`;
            }
            //
            if (props[FIELD_IS_ADDITIONAL_NUMBER_LOCATIOM] !== undefined && this.globoPrices?.additionalN) {
                //props[FIELD_IS_ADDITIONAL_NUMBER_LOCATIOM] = `${YES_TEXT} (+$${this.globoPrices.additionalN.toFixed(2)})`;
                props[FIELD_IS_ADDITIONAL_NUMBER_LOCATIOM] = `${YES_TEXT}`;
            }*/

            if (props[FIELD_IS_CUSTOM_PRINTING] !== undefined) {     
                props[FIELD_IS_CUSTOM_PRINTING] = `${YES_TEXT}`;
            }
        };

        // Like Globo, only tag a line with a unique _gpo_product_group when it has add-ons to link.
        // Otherwise identical items (same variant, no customization) must stay mergeable into one cart line.
        const hasAddons = extraOfMainProduct.length > 0 || '_gpo_addon_products' in (mainProduct.properties || {});
        const assignProductGroup = (props) => {
            if (!hasAddons) {
                delete props._gpo_product_group;
                return null;
            }

            const groupId = `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
            props._gpo_product_group = groupId;
            return groupId;
        };

        // Always include main product
        const mainProperties = structuredClone
            ? structuredClone(mainProduct.properties || {})
            : JSON.parse(JSON.stringify(mainProduct.properties || {}));

        applyYesPriceProperties(mainProperties);
        assignProductGroup(mainProperties);

        finalItems.push({
            id: mainProduct.id,
            quantity: mainProduct.quantity || 1,
            properties: mainProperties
        });

        // Add extras for the main product
        extraOfMainProduct.forEach(extra => {
            const clonedExtra = structuredClone
                ? structuredClone(extra)
                : JSON.parse(JSON.stringify(extra));

            finalItems.push(clonedExtra);
        });

        // Add roster players (if any)
        players.forEach(player => {
            if (player.isMainProduct) return;

            const variantId = this.getVariantIdByAttributes(player, mainProduct, variants);
            if (!variantId) {
                console.warn(`No variant found for player "${player.playerName}" with size "${player.size}"`);
                return;
            }

            const clonedProperties = structuredClone
                ? structuredClone(mainProduct.properties || {})
                : JSON.parse(JSON.stringify(mainProduct.properties || {}));

            this.applyRosterPlayerToProperties(clonedProperties, player);

            applyYesPriceProperties(clonedProperties);

            const groupId = assignProductGroup(clonedProperties);

            finalItems.push({
                id: variantId,
                quantity: player.quantity || 1,
                properties: clonedProperties
            });

            extraOfMainProduct.forEach(extra => {
                const clonedExtra = structuredClone
                    ? structuredClone(extra)
                    : JSON.parse(JSON.stringify(extra));

                if (clonedExtra.properties?._gpo_parent_product_group !== undefined) {
                    clonedExtra.properties['_gpo_parent_product_group'] = groupId;
                }
                finalItems.push(clonedExtra);
            });
        });

        return { items: finalItems };
    }

    getSelectedProperties() {
        const parentVariantId = document.querySelector('.product-variant-id')?.value || '';
        const properties = {
            "_gpo_product_group": parentVariantId
        };
        const getPropertyName = (rawName) => {
            const name = String(rawName || '').trim();
            const propertyMatch = name.match(/^properties\[(.*)\]$/);
            return propertyMatch ? propertyMatch[1] : name;
        };
        const shouldCollectProperty = (el, propertyName) => {
            return propertyName &&
                propertyName.charAt(0) !== '_' &&
                !el.closest?.('.no-sync');
        };

        // Select all input, select, and textarea elements
        const fields = document.querySelectorAll(
            '.gpo-container input, .gpo-container select, .gpo-container textarea'
        );

        fields.forEach(el => {
            const type = el.type;
            const name = getPropertyName(el.getAttribute('name'));
            if (!shouldCollectProperty(el, name)) return;

            // ✅ Checkbox or radio -> only if checked
            if ((type === 'checkbox' || type === 'radio') && el.checked) {
                properties[name] = el.value.trim();
            }

            // ✅ Select dropdown
            else if (el.tagName.toLowerCase() === 'select') {
                const selectedOption = el.options[el.selectedIndex];
                if (selectedOption && selectedOption.value.trim() !== '') {
                    properties[name] = selectedOption.value.trim();
                }
            }

            // ✅ Text, hidden inputs
            else if ((type === 'text' || type === 'hidden') && el.value.trim() !== '') {
                properties[name] = el.value.trim();
            }

            // ✅ File input -> get uploaded image URL instead of empty value
            else if (type === 'file') {
                const fileWrapper = el.closest('.gpo-element');
                const uploadedFile = fileWrapper?.querySelector('.gpo-f-link');
                if (uploadedFile) {
                    properties[name] = uploadedFile.getAttribute('href'); // store image URL
                }
            }

            // ✅ Textarea
            else if (el.tagName.toLowerCase() === 'textarea' && el.value.trim() !== '') {
                properties[name] = el.value.trim();
            }
        });

        const addonProducts = [];
        FIELD_CLASS_mappings.forEach(({ className }) => {
            const group = document.querySelector(`.${className}`);
            if (!group) {
                return;
            }

            const addOn = group.querySelector('.addOn');
            if (!addOn) {
                return;
            }

            if (className === FIELD_LOGO_PLACEMENT_CLASS) {
                const checkedRadio = group.querySelector('input[type="radio"]:checked');
                if (!checkedRadio) {
                    return;
                }
            } else {
                const checkbox = group.querySelector('input[type="checkbox"]');
                if (!checkbox?.checked) {
                    return;
                }
            }

            const price = parseFloat(addOn.textContent.replace(/[^\d.]/g, ''));
            if (!price) {
                return;
            }

            addonProducts.push({
                i: Number(parentVariantId),
                q: 1,
                p: String(price),
                t: 'price'
            });
        });

        const hasCustomProperties = Object.keys(properties).some((key) => (
            key &&
            key.charAt(0) !== '_' &&
            key !== 'Color' &&
            properties[key] !== undefined &&
            properties[key] !== null &&
            String(properties[key]).trim() !== ''
        ));

        if (hasCustomProperties) {
            properties.Type = 'Additional customizations';
        }

        if (addonProducts.length) {
            properties._has_gpo = this.optionSetId;
            properties._gpo_options = JSON.stringify({
                "_has_gpo": this.optionSetId,
                "Type": "Additional customizations",
            });
            properties._gpo_addon_products = JSON.stringify(addonProducts);
        }

        delete properties["Color"];

        return properties;
    }

    getExtraVariantItems() {
        const variantItems = [];
        const parentVariantId = document.querySelector('.product-variant-id')?.value || '';

        // Find all selected options with a related variant
        const selectedVariants = document.querySelectorAll('.gpo-container input[gpo-data-variant-id]:checked');

        selectedVariants.forEach(el => {
            const variantId = el.getAttribute('gpo-data-variant-id');
            const fieldName = el.getAttribute('data-field-name') || el.name;

            if (variantId) {
                variantItems.push({
                    id: Number(variantId),
                    quantity: 1,
                    properties: {
                        "_gpo_parent_product_group": parentVariantId,
                        "_gpo_field_name": fieldName
                    }
                });
            }
        });

        return variantItems;
    }

    validateRequiredFields() {
        let isValid = true;

        // Find all groups
        const groups = document.querySelectorAll('.gpo-group');

        groups.forEach(group => {
            const firstCheckbox = group.querySelector('input[type="checkbox"]');
            const messages = group.querySelectorAll('.messages');

            // Clear previous error messages
            messages.forEach(m => m.innerHTML = '');

            // If checkbox exists and is checked → validate children
            if (!firstCheckbox || firstCheckbox.checked) {
                const requiredFields = group.querySelectorAll('.gpo-label.required');

                requiredFields.forEach(label => {
                    const wrapper = label.closest('.gpo-element');
                    if (!wrapper || wrapper.getAttribute('data-clo-display') !== 'hide') {
                        return;
                    }

                    const inputs = wrapper.querySelectorAll('input, select, textarea');
                    const msg = wrapper.querySelector('.messages');
                    let hasValue = false;

                    inputs.forEach(input => {
                        const type = input.type;

                        // File input
                        if (type === 'file') {
                            const hasFile = input.files.length > 0 || wrapper.querySelector('.gpo-f-link');
                            if (hasFile) hasValue = true;
                        }

                        // Radio or checkbox
                        else if ((type === 'radio' || type === 'checkbox') && input.checked) {
                            hasValue = true;
                        }

                        // Text, hidden, select, textarea
                        else if (
                            (type === 'text' || type === 'hidden' ||
                                input.tagName.toLowerCase() === 'textarea' ||
                                input.tagName.toLowerCase() === 'select') &&
                            input.value.trim() !== ''
                        ) {
                            hasValue = true;
                        }
                    });

                    // Show error if field empty
                    if (!hasValue) {
                        isValid = false;
                        if (msg) {
                            msg.innerHTML = `<p class="help-block error">This field is required.</p>`;

                            const firstError = document.querySelector('.help-block.error');
                            const header = document.querySelector('.section-header');
                            if (firstError) {
                                const offset = header.offsetHeight;
                                const topOffset = firstError.getBoundingClientRect().top + window.scrollY - offset - 100;
                                window.scrollTo({
                                    top: topOffset,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }

                });
            }
        });

        return isValid;
    }

    initPrices() {
        const prices = {
            playerName: null,
            playerNumber: null,
            logo: null,
            anotherLogo: null,
            additionalN: null
        };        

        FIELD_CLASS_mappings.forEach(({ className, key }) => {
            const group = document.querySelector(`.${className}`);    
            if (!group) {
                return;
            }            
    
            const addOn = group.querySelector('.addOn');
            if (!addOn) {
                return;
            }

            if (className === FIELD_LOGO_PLACEMENT_CLASS) {
                const checkedRadio = group.querySelector('input[type="radio"]:checked');        
                if (!checkedRadio) {
                    return;
                }
            } else {
                const checkbox = group.querySelector('input[type="checkbox"]');        
                if (!checkbox?.checked) {
                    return;
                }
            }
    
            prices[key] = parseFloat(
                addOn.textContent.replace(/[^\d.]/g, '')
            );
        });

        this.globoPrices = prices;
    }

    addInitialPlayers() {
        const playerId = `player_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

        const mainProductData = this.getMainProductSelection();
        const globoData = this.getGloboFormData();

        const playerData = {
            id: playerId,
            quantity: mainProductData.quantity,
            size: mainProductData.size,
            playerName: globoData.player_name ? globoData.player_name : '',
            playerNumber: globoData.playerNumber ? globoData.playerNumber : '',
            price: this.calculatePlayerPrice(mainProductData.quantity, '', '', mainProductData.size),
            isMainProduct: true
        };

        this.players.push(playerData);
        this.renderPlayer(playerData);
        this.updateTotal();
    }

    getMainProductSelection() {
        const qtyInput = document.querySelector('input[name="quantity"], .quantity__input, [data-quantity-input]');
        const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        const selectedColor = this.getCurrentSelectedColor();
        this.selectedColor = selectedColor;

        let selectedSize = '';
        const sizeInput = document.querySelector('input[name="Size"]:checked, input[name="size"]:checked');
        const sizeSelect = document.querySelector('select[name="Size"], select[name="size"]');

        if (sizeInput) {
            selectedSize = sizeInput.value;
        } else if (sizeSelect) {
            selectedSize = sizeSelect.value;
        } else {
            const availableSizes = this.getAvailableSizesForColor(selectedColor);
            selectedSize = availableSizes.length > 0 ? availableSizes[0] : 'No Size Available';
        }

        return {
            quantity,
            color: selectedColor,
            size: selectedSize
        };
    }

    addPlayer() {
        const playerId = `player_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

        this.selectedColor = this.getCurrentSelectedColor();
        const availableSizes = this.getAvailableSizesForColor(this.selectedColor);
        const defaultSize = availableSizes.length > 0 ? availableSizes[0] : 'No Size Available';

        const playerData = {
            id: playerId,
            quantity: 1,
            size: defaultSize,
            playerNumber: '',
            playerName: '',
            price: this.calculatePlayerPrice(1, '', '', defaultSize)
        };

        this.players.push(playerData);
        this.renderPlayer(playerData);
        this.updateTotal();
        this.resetRosterApplyState();
    }

    renderPlayer(playerData) {
        const container = document.querySelector('.players-container');

        const globoData = this.getGloboFormData(); // returns your JSON settings
        this.selectedColor = this.getCurrentSelectedColor();

        // Separate disable flags
        const disableNumber = (!globoData.is_add_player_number || playerData.isMainProduct) ? 'disabled' : '';
        const disableName = (!globoData.is_add_player_name || playerData.isMainProduct) ? 'disabled' : '';
        const disableMain = playerData.isMainProduct ? 'disabled' : '';

        const availableSizes = this.getAvailableSizesForColor(this.selectedColor);

        // Create size options
        const sizeOptions = availableSizes.map(size =>
            `<li class="size-option" data-value="${size}" ${playerData.size === size ? 'data-selected="true"' : ''}>${size}</li>`
        ).join('');

        const selectedSize = playerData.size || availableSizes[0];

        const playerHTML = `
      <div class="player-row" data-player-id="${playerData.id}">
        <div class="quantity-col product-form__buttons">
          <quantity-input class="quantity ${disableMain}">
            <button type="button" class="quantity__button" name="minus" data-action="decrease" ${disableMain}>
              <span class="svg-wrapper">
                <svg aria-hidden="true" focusable="false" class="icon icon-minus">
                  <use href="#icon-minus"></use>
                </svg>
              </span>
            </button>
            <input class="quantity__input" type="number" value="${playerData.quantity}" min="1" max="10" ${disableMain}>
            <button type="button" class="quantity__button" name="plus" data-action="increase" ${disableMain}>
              <span class="svg-wrapper">
                <svg aria-hidden="true" focusable="false" class="icon icon-plus">
                  <use href="#icon-plus"></use>
                </svg>
              </span>
            </button>
          </quantity-input>
        </div>
        
        <div class="size-col">
          <div class="size-select ${disableMain}" data-player-id="${playerData.id}">
            <div class="select-display" data-value="${selectedSize}">
              <span class="select-text">${selectedSize}</span>
            </div>
            <ul class="select-dropdown">
              ${sizeOptions}
            </ul>
          </div>
        </div>
        
        <div class="player-number-col">
          <input type="number" class="player-number field__input" placeholder="Enter Number" min="0" max="99" value="${playerData.playerNumber}" ${disableNumber}>
        </div>
        
        <div class="player-name-col">
          <input type="text" class="player-name field__input" placeholder="Enter Name" maxlength="10" value="${playerData.playerName}" ${disableName}>
        </div>
        
        <div class="price-col">
          <span class="player-price">$${playerData.price.toFixed(2)}</span>
        </div>
        
        <div class="remove-col">
          ${playerData.isMainProduct ? `
            <button type="button" class="remove-player-btn" disabled title="Cannot remove main player" style="opacity: 0.4; cursor: not-allowed;">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M18.5 7H19C19.5523 7 20 6.55228 20 6V5.5C20 4.94772 19.5523 4.5 19 4.5H16M18.5 7V19C18.5 20.1046 17.6046 21 16.5 21H8.5C7.39543 21 6.5 20.1046 6.5 19V7M18.5 7H6.5M16 4.5V4C16 2.89543 15.1046 2 14 2H11C9.89543 2 9 2.89543 9 4V4.5M16 4.5H9M6.5 7H6C5.44772 7 5 6.55228 5 6V5.5C5 4.94772 5.44772 4.5 6 4.5H9M10.5 10.5V17.5M14.5 10.5V17.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
            </button>
          ` : `
            <button type="button" class="remove-player-btn" data-player-id="${playerData.id}">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M18.5 7H19C19.5523 7 20 6.55228 20 6V5.5C20 4.94772 19.5523 4.5 19 4.5H16M18.5 7V19C18.5 20.1046 17.6046 21 16.5 21H8.5C7.39543 21 6.5 20.1046 6.5 19V7M18.5 7H6.5M16 4.5V4C16 2.89543 15.1046 2 14 2H11C9.89543 2 9 2.89543 9 4V4.5M16 4.5H9M6.5 7H6C5.44772 7 5 6.55228 5 6V5.5C5 4.94772 5.44772 4.5 6 4.5H9M10.5 10.5V17.5M14.5 10.5V17.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
            </button>
          `}
        </div>
      </div>
    `;

        container.insertAdjacentHTML('beforeend', playerHTML);
        this.bindPlayerEvents(playerData.id);
    }

    bindDropdownEvents() {
        document.addEventListener('click', (e) => {
            if (e.target.closest('.select-display')) {
                const customSelect = e.target.closest('.size-select');
                const dropdown = customSelect.querySelector('.select-dropdown');

                document.querySelectorAll('.size-select').forEach(select => {
                    if (select !== customSelect) {
                        select.classList.remove('open');
                    }
                });

                customSelect.classList.toggle('open');
            }

            else if (e.target.classList.contains('size-option')) {
                const option = e.target;
                const customSelect = option.closest('.size-select');
                const playerId = customSelect.dataset.playerId;
                const selectedValue = option.dataset.value;
                const selectedText = option.textContent;

                const display = customSelect.querySelector('.select-display');
                const textSpan = display.querySelector('.select-text');
                textSpan.textContent = selectedText;
                display.dataset.value = selectedValue;

                customSelect.querySelectorAll('.size-option').forEach(opt => {
                    opt.removeAttribute('data-selected');
                });
                option.setAttribute('data-selected', 'true');

                customSelect.classList.remove('open');

                this.updatePlayer(playerId, { size: selectedValue });

                const player = this.players.find(p => p.id === playerId);
                if (player && player.isMainProduct) {
                    this.syncToMainProductForm('size', selectedValue);
                }
            }

            else if (!e.target.closest('.size-select')) {
                document.querySelectorAll('.size-select').forEach(select => {
                    select.classList.remove('open');
                });
            }
        });
    }

    getSelectedSize(playerId) {
        const customSelect = document.querySelector(`[data-player-id="${playerId}"] .size-select`);
        return customSelect ? customSelect.querySelector('.select-display').dataset.value : '';
    }

    setSelectedSize(playerId, size) {
        const customSelect = document.querySelector(`[data-player-id="${playerId}"] .size-select`);
        const option = customSelect ? customSelect.querySelector(`[data-value="${size}"]`) : null;

        if (option && customSelect) {
            const display = customSelect.querySelector('.select-display');
            const textSpan = display.querySelector('.select-text');
            textSpan.textContent = size;
            display.dataset.value = size;

            customSelect.querySelectorAll('.size-option').forEach(opt => {
                opt.removeAttribute('data-selected');
            });
            option.setAttribute('data-selected', 'true');
        }
    }

    bindPlayerEvents(playerId) {
        const playerRow = document.querySelector(`[data-player-id="${playerId}"]`);
        const player = this.players.find(p => p.id === playerId);

        playerRow.querySelectorAll('.qty-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const action = e.target.dataset.action;
                const input = playerRow.querySelector('.quantity__input');
                let value = parseInt(input.value);

                if (action === 'increase' && value < 10) {
                    value++;
                } else if (action === 'decrease' && value > 1) {
                    value--;
                }

                input.value = value;
                this.updatePlayer(playerId, { quantity: value });

                if (player && player.isMainProduct) {
                    this.syncToMainProductForm('quantity', value);
                }
            });
        });

        playerRow.querySelector('.quantity__input').addEventListener('change', (e) => {
            const value = parseInt(e.target.value);
            this.updatePlayer(playerId, { quantity: value });

            if (player && player.isMainProduct) {
                this.syncToMainProductForm('quantity', value);
            }
        });

        playerRow.querySelector('.player-number').addEventListener('input', (e) => {
            this.updatePlayer(playerId, { playerNumber: e.target.value });

            if (player && player.isMainProduct) {
                this.syncToMainProductForm('player_number', e.target.value);
            }
        });

        playerRow.querySelector('.player-name').addEventListener('input', (e) => {
            this.updatePlayer(playerId, { playerName: e.target.value });

            if (player && player.isMainProduct) {
                this.syncToMainProductForm('player_name', e.target.value);
            }
        });
    }

    syncToMainProductForm(field, value) {
    }

    updatePlayer(playerId, updates) {
        const playerIndex = this.players.findIndex(p => p.id === playerId);
        if (playerIndex !== -1) {
            Object.assign(this.players[playerIndex], updates);

            const player = this.players[playerIndex];
            player.price = this.calculatePlayerPrice(
                player.quantity,
                player.playerName,
                player.playerNumber,
                player.size
            );

            const playerRow = document.querySelector(`[data-player-id="${playerId}"]`);
            playerRow.querySelector('.player-price').textContent = `$${player.price.toFixed(2)}`;

            this.updateTotal();
        }
    }

    calculatePlayerPrice(quantity, hasName = '', hasNumber = '', playerSize = '') {
        this.selectedColor = this.getCurrentSelectedColor();
        const variant = this.getVariantByOptions(this.selectedColor, playerSize);
        let unitPrice = variant ? (variant.price / 100) : 0;

        const globoData = this.getGloboFormData();

        if (globoData.is_add_logo) {
            unitPrice += this.globoPrices.logo;
        }
        if (globoData.is_add_another_logo) {
            unitPrice += this.globoPrices.anotherLogo;
        }

        if (globoData.is_add_player_name) {
            unitPrice += this.globoPrices.playerName;
        }

        if (globoData.is_add_player_number) {
            unitPrice += this.globoPrices.playerNumber;
        }

        if (globoData.is_add_additional_number_location) {
            unitPrice += this.globoPrices.additionalN;
        }

        const totalPrice = unitPrice * quantity;

        return totalPrice;
    }

    updateTotal() {
        const total = this.players.reduce((sum, player) => sum + player.price, 0);
        const totalElement = document.querySelector('.total-price');
        if (totalElement) {
            totalElement.textContent = `Total: $${total.toFixed(2)}`;
        }

        this.updateRosterSummary()
        //this.updateAddToCartTotal(total);
    }

    updateRosterSummary() {
        try {
            const totalQuantity = this.players.reduce((sum, p) => sum + (p.quantity || 0), 0);
            const { is_add_logo, is_add_another_logo, is_add_player_number, is_add_player_name, is_add_additional_number_location } = this.getGloboFormData();
            const { logo = 0, anotherLogo = 0, playerNumber = 0, playerName = 0 } = this.globoPrices;

            // Update total quantity
            document.getElementById('total-roster-qty')?.setAttribute('value', totalQuantity);

            // Logo price
            const totalLogoPrice = (is_add_logo ? logo : 0) + (is_add_another_logo ? anotherLogo : 0);
            //additional number price
            let additionalNPrice = 0;
            if (is_add_additional_number_location) {
                additionalNPrice = this.globoPrices.additionalN || 0;
            }
            const logoPriceElement = document.getElementById('roster-logo-price');
            const logoTextEl = logoPriceElement?.parentElement?.querySelector('.additionalPrice-text');

            const labels = [];

if (totalLogoPrice > 0) {
    labels.push(`LOGO +$${totalLogoPrice.toFixed(2)}`);
}

if (additionalNPrice > 0) {
    labels.push(`ADDITIONAL NUMBER +$${additionalNPrice.toFixed(2)}`);
}
if (logoPriceElement) {
    if (labels.length) {
        logoPriceElement.textContent = '';
        logoPriceElement.style.display = 'none';

        if (logoTextEl) {
            logoTextEl.textContent = labels.join(' | ');
            logoTextEl.style.display = 'inline';
        }
    } else {
        logoPriceElement.style.display = 'none';

        if (logoTextEl) {
            logoTextEl.style.display = 'none';
        }
    }
}

/*
            if (logoPriceElement) {
                if (totalLogoPrice > 0) {
                    logoPriceElement.textContent = `+$${totalLogoPrice.toFixed(2)}`;
                    logoPriceElement.style.display = 'inline';
                    if (logoTextEl) {
                        logoTextEl.textContent = (is_add_logo && is_add_another_logo) ? "LOGOS" : "LOGO";
                        logoTextEl.style.display = 'inline';
                    }
                } else {
                    logoPriceElement.style.display = 'none';
                    if (logoTextEl) logoTextEl.style.display = 'none';
                }
            }*/

            // Player number price
            const numPriceEl = document.getElementById('roster-playernu-price');
            if (numPriceEl) {
                numPriceEl.textContent = (is_add_player_number && playerNumber)
                    ? `(+$${playerNumber.toFixed(2)} per player)`
                    : '';
            }

            // Player name price
            const namePriceEl = document.getElementById('roster-playerna-price');
            if (namePriceEl) {
                namePriceEl.textContent = (is_add_player_name && playerName)
                    ? `(+$${playerName.toFixed(2)} per player)`
                    : '';
            }

        } catch (error) {
            console.error('Error updating roster summary:', error);
        }
    }

    updateAddToCartTotal() {
        const addToCartBtn = document.querySelector('button[name="add"].product-form__submit span');
        if (!addToCartBtn) {
            return;
        }

        const baseText = addToCartBtn.dataset.originalText || addToCartBtn.textContent.trim() || 'Add to cart';
        if (!addToCartBtn.dataset.originalText) {
            addToCartBtn.dataset.originalText = baseText;
        }

        if (!this.isRosterApplied()) {
            addToCartBtn.textContent = baseText;
            return;
        }

        const totalAmount = this.players.reduce((sum, player) => sum + player.price, 0);
        const formattedTotal = totalAmount > 0 ? ` $${totalAmount.toFixed(2)}` : '';
        addToCartBtn.textContent = `${baseText}${formattedTotal}`;
    }

    removePlayer(playerId) {

        this.players = this.players.filter(p => p.id !== playerId);
        const playerElement = document.querySelector(`[data-player-id="${playerId}"]`);
        if (playerElement) {
            playerElement.remove();
        }
        this.resetRosterApplyState();
        this.updateTotal();

        //this.logCartData();
    }

    getGloboFormData() {
        const globoContainer = document.querySelector('.gpo-container');
        if (!globoContainer) return {};

        const getVal = (selector, prop = 'value') => globoContainer.querySelector(selector)?.[prop] || '';
        const getChecked = (selector) => globoContainer.querySelector(selector)?.checked || false;
        //const getHref = (selector) => globoContainer.querySelector(selector)?.closest('.gpo-element')?.querySelector('.gpo-f-card .gpo-f-link')?.href || '';
        const getHref = (className) => {
            const group = globoContainer
                .querySelector(`.${className}`)
                ?.closest('.gpo-group__childs');        
            return group?.querySelector('.gpo-f-card .gpo-f-link')?.href || '';
        };
        const hasCheckedCheckbox = (className) => {
            return !!document.querySelector(
                `.${className} input[type="checkbox"]:checked`
            );
        };
        const getCheckedRadioValue = (className) => {
            return document.querySelector(
                `.${className} input[type="radio"]:checked`
            )?.value || '';
        };

        const gbData = {
            // Logo
            //is_add_logo: getChecked(`input[name="${FIELD_IS_ADD_LOGO}"]`),
            is_add_logo: hasCheckedCheckbox(`${FIELD_LOGO_CLASS}`),
            logo_placement: getCheckedRadioValue(`${FIELD_LOGO_PLACEMENT_CLASS}`),
            logo: getHref(FIELD_LOGO_CLASS),

            // Another logo
            is_add_another_logo: hasCheckedCheckbox(`${FIELD_ANOTHER_LOGO_CLASS}`),
            another_logo_placement: getCheckedRadioValue(`${FIELD_ANOTHER_LOGO_PLACEMENT_CLASS}`),
            another_logo: getHref(`${FIELD_ANOTHER_LOGO_CLASS}`),

            // Player Name
            is_add_player_name: hasCheckedCheckbox(`${FIELD_PLAYER_NAME_CLASS}`),
            player_font_name: getVal(`input[name="${FIELD_PLAYER_FONT_NAME}"]`),
            player_name_color: getVal(`input[name="${FIELD_PLAYER_NAME_COLOR}"]:checked`),
            player_name: this.getActiveGloboPlayerNameInput()?.value?.trim() || '',

            // Player Number
            is_add_player_number: hasCheckedCheckbox(`${FIELD_PLAYER_NUMBER_CLASS}`),
            playerNumber: this.getActiveGloboPlayerNumberInput()?.value?.trim() || '',
            player_number_location: getCheckedRadioValue(`${FIELD_PLAYER_NUMBER_LOCATION_CLASS}`),
            player_number_style: getVal(`input[name="${FIELD_NUMBER_STYLE}"]:checked`),
            player_number_color: getVal(`input[name="${FIELD_NUMBER_COLOR}"]:checked`),

            is_add_additional_number_location: hasCheckedCheckbox(`${FIELD_ADDITIONAL_PLAYER_NUMBER_CLASS}`),
            additional_player_number_location: getCheckedRadioValue(`${FIELD_ADDITIONAL_PLAYER_NUMBER_LOCATION_CLASS}`),

            // Custom Printing
            is_custom_printing: hasCheckedCheckbox(`${FIELD_IS_CUSTOM_PRINTING_CLASS}`),
            custom_printing: getHref(`${FIELD_IS_CUSTOM_PRINTING_CLASS}`),
            custom_printing_description: getVal(`textarea[name="${FIELD_IS_CUSTOM_PRINTING_DESC}"]`)
        };

        return gbData;
    }

    async saveRoster() {
        try {
            if (!this.players.length) {
                throw new Error('Please add at least one player');
            }

            const { is_add_player_number: checkNumber, is_add_player_name: checkName } = this.getGloboFormData();
            let hasError = false;

            // Clear previous highlights
            document.querySelectorAll('.player-name.error, .player-number.error')
                .forEach(el => el.classList.remove('error'));

            // Validate player fields
            document.querySelectorAll('.player-row').forEach(row => {
                const nameInput = row.querySelector('.player-name');
                const numberInput = row.querySelector('.player-number');

                if (checkName && (!nameInput?.value.trim())) {
                    nameInput?.classList.add('error');
                    hasError = true;
                }

                if (checkNumber && (!numberInput?.value.trim())) {
                    numberInput?.classList.add('error');
                    hasError = true;
                }
            });

            if (hasError) {
                throw new Error('Please fill all highlighted fields before saving the roster.');
            }

            const savedRoster = this.saveRosterToStorage();

            if (savedRoster) {
                const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
                this.closeRosterModal(currentScrollY);

                this.setRosterApplyState(true);
                this.toggleIsApplyCreateRoster();
                this.updateTotal();
                this.updateAddToCartTotal();
            }
        } catch (error) {
            console.error('Error saving roster:', error);
            alert('Error: ' + error.message);
        }
    }

    closeRosterModal(scrollY = null) {
        const modal = document.querySelector('[id*="CreateRoster"]');
        if (modal) {
            if (typeof modal.hide === 'function') {
                modal.hide();
            } else {
                // Fallback for safety if the custom element is not ready.
                modal.removeAttribute('open');
                modal.classList.remove('active', 'open', 'animate');
                document.documentElement.classList.remove('modal-show', 'overflow-hidden', 'is-modal-open');
                document.body.classList.remove('modal-show', 'overflow-hidden', 'is-modal-open');
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
            }

            if (typeof scrollY === 'number') {
                requestAnimationFrame(() => {
                    window.scrollTo({ top: scrollY, behavior: 'auto' });
                });
            }
        }
    }

    toggleIsApplyCreateRoster() {
        const isApplyRosterTeam = document.querySelector('input[name="is_apply_create_roster"]');
        const toggleApplyButton = document.getElementById('tongle-apply-roster');
        const teamRosterNotification = document.getElementById('notification-team-roster');
        //const notificationRoster = document.getElementById('notification-roster');

        if (!isApplyRosterTeam) {
            return;
        }

        isApplyRosterTeam.value = 'true';
        isApplyRosterTeam.checked = true;

        if (isApplyRosterTeam.value === 'true') {
            toggleApplyButton.textContent = 'Saved';
            teamRosterNotification.textContent = 'Your team roster has been applied. Add to cart to buy it.';
            //notificationRoster.textContent='Saved';
        }
    }

    resetRosterApplyState() {
        const isApplyRosterInput = document.querySelector('input[name="is_apply_create_roster"]');
        const toggleApplyButton = document.getElementById('tongle-apply-roster');
        const teamRosterNotification = document.getElementById('notification-team-roster');
        //const notificationRoster = document.getElementById('notification-roster');

        if (isApplyRosterInput) {
            isApplyRosterInput.value = 'false';
            isApplyRosterInput.checked = false;
        }

        if (toggleApplyButton) {
            toggleApplyButton.textContent = 'Save';
        }

        if (teamRosterNotification) {
            teamRosterNotification.textContent = 'BUYING FOR MULTIPLE PLAYERS? CREATE A TEAM ROSTER';
        }

        /*if (notificationRoster) {
          notificationRoster.textContent = 'Not apply';
        }*/

        // Reset Add to cart button text
        const addToCartBtn = document.querySelector('button[name="add"].product-form__submit span');
        if (addToCartBtn && addToCartBtn.dataset.originalText) {
            addToCartBtn.textContent = addToCartBtn.dataset.originalText;
        }

        this.updateAddToCartTotal();
    }

    updatePricing() {
        this.players.forEach(player => {
            player.price = this.calculatePlayerPrice(
                player.quantity,
                player.playerName,
                player.playerNumber,
                player.size
            );
        });

        this.players.forEach(player => {
            const playerRow = document.querySelector(`[data-player-id="${player.id}"]`);
            if (playerRow) {
                const priceElement = playerRow.querySelector('.player-price');
                if (priceElement) {
                    priceElement.textContent = `$${player.price.toFixed(2)}`;
                }
            }
        });

        this.updateTotal();
    }

    saveRosterToStorage() {
        try {
            this.selectedColor = this.getCurrentSelectedColor();

            if (!this.players.length) {
                throw new Error('Please add at least one player to save');
            }

            const validPlayers = this.players.filter(p =>
                p && typeof p === 'object' && p.id && !isNaN(p.quantity) && p.size
            );

            if (!validPlayers.length) {
                throw new Error('No valid players found to save');
            }

            const rosterData = {
                createdAt: new Date().toISOString(),
                players: validPlayers.map(p => ({
                    id: p.id,
                    quantity: parseInt(p.quantity) || 1,
                    size: p.size || '',
                    playerNumber: p.playerNumber?.toString().trim() || '',
                    playerName: p.playerName?.toString().trim() || '',
                    isMainProduct: !!p.isMainProduct
                })),
                selectedColor: this.selectedColor || '',
                globoSettings: this.getGloboFormData() || {},
                cartKey: this.cartKey
            };

            localStorage.setItem('savedTeamRoster', JSON.stringify(rosterData));
            return rosterData;

        } catch (error) {
            console.error('Error saving roster:', error);
            return null;
        }
    }

    getSavedRoster() {
        try {
            const saved = localStorage.getItem('savedTeamRoster');
            if (!saved || saved.trim() === '' || saved === 'null' || saved === 'undefined') {
                return null;
            }

            const roster = JSON.parse(saved);

            if (roster.cartKey !== this.cartKey) {
                localStorage.removeItem('savedTeamRoster');
                return null;
            }

            return roster;
        } catch (error) {
            localStorage.removeItem('savedTeamRoster');
            return null;
        }
    }

    loadRosterFromStorage() {
        try {
            const roster = this.getSavedRoster();
            if (!roster) return;

            this.clearAllPlayers();
            this.selectedColor = this.getCurrentSelectedColor();

            const globoData = this.getGloboFormData();
            const availableSizes = this.getAvailableSizesForColor(this.selectedColor);

            const validPlayers = (roster.players || [])
                .filter(p => p && typeof p === 'object')
                .map(player => {
                    try {
                        const data = {
                            id: player.id || `player_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                            quantity: parseInt(player.quantity) || 1,
                            size: availableSizes.includes(player.size) ? player.size : (availableSizes[0] || 'No Size Available'),
                            playerNumber: (player.isMainProduct ? globoData?.playerNumber : player.playerNumber)?.toString().trim() || '',
                            playerName: (player.isMainProduct ? globoData?.player_name : player.playerName)?.toString().trim() || '',
                            isMainProduct: !!player.isMainProduct
                        };

                        data.price = this.calculatePlayerPrice(
                            data.quantity, data.playerName, data.playerNumber, data.size
                        );

                        return data;
                    } catch (e) {
                        console.error('Error validating player:', e, player);
                        return null;
                    }
                })
                .filter(Boolean);

            if (!validPlayers.length) throw new Error('No valid players could be loaded from roster');

            validPlayers.forEach(player => {
                this.players.push(player);
                this.renderPlayer(player);
            });

            this.updateTotal();
            this.setRosterApplyState(true);
            this.updateAddToCartTotal();

        } catch (error) {
            console.error('Error loading roster:', error);
        }
    }

    clearPersistedRosterOnInit() {
        const roster = this.getSavedRoster();
        if (!roster) {
            this.resetRosterApplyState();
            return;
        }

        localStorage.removeItem('savedTeamRoster');
        this.clearAllPlayers();
        this.resetRosterApplyState();
    }

    clearRosterSession() {
        localStorage.removeItem('savedTeamRoster');
        this.clearAllPlayers();
        this.resetRosterApplyState();
    }

    invalidateRosterState() {
        localStorage.removeItem('savedTeamRoster');
        this.resetRosterApplyState();
        this.updateAddToCartTotal();
    }

    clearAllPlayers() {
        try {
            this.players = [];

            const container = document.querySelector('.players-container');
            if (container) {
                container.innerHTML = '';
            }

            this.updateTotal();
        } catch (error) {
            console.error('❌ Error clearing players:', error);
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const initTeamRoster = () => {
        try {
            const gpoApp = document.querySelector('.gpo-app');
    
            if (!gpoApp?.dataset.optionSetId) {
                setTimeout(initTeamRoster, 300);
                return;
            }
    
            window.teamRoster = new TeamOrderRoster({
                productId: productData.productId,
                variantId: productData.variantId,
                variants: productData.variants || [],
                productOptions: productData.options || []
            });
    
        } catch (error) {
            console.error('❌ Error creating TeamOrderRoster:', error);
        }
    };

    if (typeof productData === 'undefined') {

        let attempts = 0;
        const checkProductData = setInterval(() => {
            attempts++;
            if (typeof productData !== 'undefined' || attempts > 20) {
                clearInterval(checkProductData);
                if (typeof productData !== 'undefined') {
                    initTeamRoster();
                } else {
                    console.error('❌ productData never loaded');
                }
            }
        }, 100);
    } else {
        setTimeout(initTeamRoster, 300);
    }
});

if (typeof module !== 'undefined' && module.exports) {
    module.exports = TeamOrderRoster;
}
